import * as React from "react";
import { PromotionBlock } from "../../../../../../../../../PromotionBlock/lib-components/PromotionBlock/PromotionBlock.js";
import { BannerRecommendationAction } from "../../../../../../../../lib-components/RecommendedProducts/types.js";
import { convertBannerRecommendationInfo } from "../../../../../../../../utils/lib-components/RecommendedProducts/utils/mappers.js";
const BannerRecommendation = React.forwardRef(
  ({ recommendation, onClick, className, tabIndex }, ref) => {
    const info = convertBannerRecommendationInfo(recommendation);
    if (!info) return null;
    let link;
    if (info.action && info.action === BannerRecommendationAction.Link) {
      link = info.link;
    }
    return /* @__PURE__ */ React.createElement(
      PromotionBlock,
      {
        ref,
        id: `banner-recommendation_${info.title}`,
        ctaLabel: link?.label || "",
        size: "small",
        links: { ...link, style: "" },
        ...info,
        onClick,
        className,
        tabIndex
      }
    );
  }
);
export {
  BannerRecommendation
};
//# sourceMappingURL=BannerRecommendation.js.map
